export default __webpack_public_path__ + "static/media/graduation.e797da27.svg";